import React from 'react'

export function MailIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#2AAD87"
        fillRule="evenodd"
        d="M1.25 4.5A.75.75 0 012 3.75h20a.75.75 0 01.75.75v15a.75.75 0 01-.75.75H2a.75.75 0 01-.75-.75v-15zm1.5.75v13.5h18.5V5.25H2.75z"
        clipRule="evenodd"
      />
      <path
        fill="#2AAD87"
        fillRule="evenodd"
        d="M1.4 4.05a.75.75 0 011.05-.15L12 11.062 21.55 3.9a.75.75 0 01.9 1.2l-10 7.5a.75.75 0 01-.9 0l-10-7.5a.75.75 0 01-.15-1.05z"
        clipRule="evenodd"
      />
      <path
        fill="#2AAD87"
        fillRule="evenodd"
        d="M1.25 4.5A.75.75 0 012 3.75h10a.75.75 0 010 1.5H2.75V12a.75.75 0 01-1.5 0V4.5z"
        clipRule="evenodd"
      />
      <path
        fill="#2AAD87"
        fillRule="evenodd"
        d="M11.25 4.5a.75.75 0 01.75-.75h10a.75.75 0 01.75.75V12a.75.75 0 01-1.5 0V5.25H12a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}
